/* eslint-disable */
import React, { useContext, useEffect, useMemo, useState } from 'react';

import './_page-view.scss';
import './_page-view.dark-mode.scss';

import { useLocation, useHistory } from 'react-router-dom';
import { Button, Col, Grid, Row, Panel } from 'react-bootstrap';
import qs from 'qs';
import {
  pagesCreate,
  pagesDelete,
  pagesEdit,
  pagesLanguagesActive,
  pagesView,
} from '../../../../services/endpoints/pages';
import PagesForm from './components/Form';
import ModalsManager from './components/Modals/Manager';
import NavRoutes from '../../../../components/Navs/NavRoutes';
import { AppearanceContext } from '../../index';
import AlertComponent from '../../../../components/Alert';
import { getErrorMessage, pageWrapperScrollTop } from '../../../../utils/helper';
import { createLanguagesData } from './helpers';
import PageNotFound from '../../../404';
import { routesAppearance } from '../../helpers';
import { IS_LOCAL } from '../../../../utils/config';
import Loader from '../../../../components/Loaders/Loader';
import { cloneDeep } from 'lodash';
import { checkForTags, processHtml, revertHtml } from '../../../../components/Summernote/helpers';
import { htmlParsesDomainsWithSu } from '../../../../components/Summernote';

const PagesView = () => {
  const location = useLocation();
  const history = useHistory();

  const queryString = qs.parse(location.search.slice(1));

  const { config, menu } = useContext(AppearanceContext);

  const routePages = useMemo(() => routesAppearance.find((route) => route.code === 'pages'), [])
  const routeCreatePage = useMemo(() => routesAppearance.find((route) => route.code === 'create-page'), [])
  const isCreatePage = location.pathname === routeCreatePage.link;

  const [init, setInit] = useState(false);
  const [data, setData] = useState({
    page: {
      access: {
        content_edit: true,
        public_change: true,
        public_show: true,
        delete: false,
        url_edit: true,
      },
      url: '',
      page_name: {},
      page_content: {},
      seo_title: {},
      seo_keywords: {},
      seo_description: {},
      visibility: true,
      is_deleted: false,
      is_public: true,
      is_system: false,
    },
    default_language: null,
    languages: [],
  });
  const [error, setError] = useState(null)
  const [errorForm, setErrorForm] = useState(null)
  const [isLoading, setIsLoading] = useState({ page: true, form: false, modalSubmit: false });
  const [openModal, setOpenModal] = useState('');
  const [modalData, setModalData] = useState({});

  const { page, default_language, languages } = data;

  const isDeletePage = page?.access?.delete;
  const fetchList = async () => {
    setIsLoading((prevState) => ({ ...prevState, form: true }));
    try {
      if (isCreatePage) {
        const response = await pagesLanguagesActive();
        if (response.success) {
          const languagesData = createLanguagesData(response.data.languages);
          setData((prevState) => {
            return {
              ...prevState,
              page: {
                ...prevState.page,
                page_name: languagesData.codes,
                page_content: languagesData.codes,
                seo_title: languagesData.codes,
                seo_keywords: languagesData.codes,
                seo_description: languagesData.codes,
              },
              default_language: languagesData.default_language,
              languages: languagesData.languages,
            }
          })
          setIsLoading((prevState) => ({ ...prevState, form: false }));
          return response.data;
        }
      } else {
        const response = await pagesView(queryString.id);
        if (response.success) {
          // Для опредленных доменов
          if (htmlParsesDomainsWithSu.includes(window.location.hostname) || IS_LOCAL) {
            const newPageContent = cloneDeep(response.data.page.page_content);
            Object.keys(newPageContent).forEach((key) => {
              if (checkForTags(newPageContent[key])) {
                newPageContent[key] = processHtml(newPageContent[key])
              }
            })
            setData((prevState) => {
              return {
                ...prevState,
                ...response.data,
                page: {
                  ...response.data.page,
                  page_content: newPageContent
                }
              }
            });
          } else {
            setData(response.data)
          }
        }
        setIsLoading((prevState) => ({ ...prevState, form: false }));
        return response.data;
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, form: false }));
    }
  };

  const getAllData = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));

    try {
      if (config?.access?.pages_edit) {
        await fetchList(queryString);
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      } else {
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      }
      setInit(true);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  }

  const onCancel = () => {
    history.push(routePages.link)
  }

  const onChangeForm = (formData) => {
    setData((prevState) => ({
      ...prevState,
      page: formData,
    }))
  }

  const onHideModals = () => {
    setOpenModal('');
    setModalData({});
  };

  const onDeletePageConfirm = async () => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await pagesDelete(queryString.id)
      onHideModals('');
      history.push(routePages.link);
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
    }
  }

  const onSubmitModal = async () => {
    switch (modalData?.actionType) {
      case 'single':
        if (modalData?.title === 'Delete page') {
          await onDeletePageConfirm()
        }
        break;

      default:
        break;
    }
  };

  const onDeletePage = (e) => {
    e.preventDefault();
    setModalData({
      actionKey: 'delete',
      title: 'Delete page',
      description: '',
      actionType: 'single',
      item: {},
    });
    setOpenModal('confirm');
  }

  const onSubmit = async () => {
    try {
      setIsLoading((prevState) => ({ ...prevState, form: true }));
      const editPage = cloneDeep(page);
      if (htmlParsesDomainsWithSu.includes(window.location.hostname)) {
        Object.keys(editPage.page_content).forEach((key) => {
          editPage.page_content[key] = revertHtml(editPage.page_content[key])
        })
      }

      isCreatePage ? await pagesCreate(page) : await pagesEdit(queryString.id, editPage);
      history.push(routePages.link)
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setErrorForm(errorMessage);
      pageWrapperScrollTop();
      setIsLoading((prevState) => ({ ...prevState, form: false }));
    }
  }

  useEffect(() => {
    getAllData()
    document.title = isCreatePage ? 'Add page' : 'Edit page';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading.page && !init) {
    return <Loader />;
  }

  if (!config?.access?.pages_edit) {
    return <PageNotFound />
  }

  return (
    <Grid>
      <ModalsManager
        open={openModal}
        isLoading={isLoading.modal}
        isLoadingSubmit={isLoading.modalSubmit}
        modalData={modalData}
        values={[]}
        statuses={config?.statuses}
        onSubmit={onSubmitModal}
        onHide={onHideModals}
      />
      <Row>
        <Col md={2} mdOffset={1}>
          <NavRoutes
            routes={menu}
          />
        </Col>
        <Col md={8}>
          <div className="loader-container page-view" style={{ minHeight: '600px' }}>
            {error
              ? <AlertComponent text={error} />
              : (
                <div>
                  {config?.access?.pages_edit
                    ? (
                      <Panel>
                        <Panel.Body>
                          {errorForm ? <AlertComponent text={errorForm} /> : null}
                          <PagesForm
                            page={page}
                            default_language={default_language}
                            languages={languages}
                            isLoading={isLoading.form}
                            isCreatePage={isCreatePage}
                            onChange={onChangeForm}
                          />
                          <hr />
                          <div className="page-view__footer">
                            <Button bsStyle="primary" onClick={onSubmit} disabled={isLoading.form}>Save changes</Button>
                            {' '}
                            <Button onClick={onCancel} disabled={isLoading.form}>Cancel</Button>
                            {isDeletePage && config?.access?.pages_delete ? <a href="#delete" onClick={onDeletePage}
                                                                               className="btn btn-link pull-right delete-btn">Delete</a> : null}
                          </div>
                        </Panel.Body>
                      </Panel>
                    ) : null}
                </div>
              )}
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default PagesView;
